import { render, staticRenderFns } from "./DefaultProjectImageNewDashBoard.vue?vue&type=template&id=0c66a830"
import script from "./DefaultProjectImageNewDashBoard.vue?vue&type=script&lang=ts"
export * from "./DefaultProjectImageNewDashBoard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c66a830')) {
      api.createRecord('0c66a830', component.options)
    } else {
      api.reload('0c66a830', component.options)
    }
    module.hot.accept("./DefaultProjectImageNewDashBoard.vue?vue&type=template&id=0c66a830", function () {
      api.rerender('0c66a830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/DefaultProjectImageNewDashBoard.vue"
export default component.exports